import React from 'react';

import PsychToolPageBase, { PsychToolPageProps } from './PsychToolPageBase';

const PsychDarkPage: React.FC<PsychToolPageProps> = ({ onBack, onRequireLogin }) => (
  <PsychToolPageBase onBack={onBack} onRequireLogin={onRequireLogin} testId='dark' />
);

export default PsychDarkPage;
